import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { reportError } from 'helpers/error-reporting';
import { ExternalLink } from 'next/components/ui';

const UPGRADE_SUBJECT = 'Upgrading plan limits';
const UPGRADE_MESSAGE = [
  'Hi,',
  "I'd like to upgrade my Appcues plan to have a greater range in my date range reporting.",
  'Thanks!',
].join('\n\n');

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export default function HistoricalLimitExceeded({ limit = 0, user = {} }) {
  // Handle potential upsell request. If the Helpscout beacon exists on the
  // page, use that to contact the sales team. However if the beacon fails or
  // does not exist on the page, fallback to using a mailto link
  const handleClick = event => {
    if (window.Beacon) {
      try {
        /* eslint-disable new-cap */
        window.Beacon('prefill', {
          name: user.fullname || '',
          email: user.email || '',
          subject: UPGRADE_SUBJECT,
          text: UPGRADE_MESSAGE,
        });
        window.Beacon('navigate', '/ask/');
        window.Beacon('open');
        /* eslint-enable new-cap */

        event.preventDefault();
      } catch (error) {
        reportError(error);
      }
    }
  };

  // Humanized label for historical limit
  const label =
    limit <= 90 ? `${limit} days` : `${Math.floor(limit / 30)} months`;

  return (
    <Wrapper>
      Your plan is limited to {label} of historical data.
      <ExternalLink
        href={`mailto:sales@appcues.com?subject=${encodeURIComponent(
          UPGRADE_SUBJECT
        )}&body=${encodeURIComponent(UPGRADE_MESSAGE)}`}
        onClick={handleClick}
      >
        Contact sales to upgrade
      </ExternalLink>
    </Wrapper>
  );
}

HistoricalLimitExceeded.propTypes = {
  limit: PropTypes.number,
  user: PropTypes.shape({
    email: PropTypes.string,
    fullname: PropTypes.string,
  }),
};
